import { useState, useMemo, useEffect, useContext, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

import { getAuthorizationToken } from "@/auth/tokenStore";
import CaseTabLitigation from "@/Components/LitigationDashboard/new-components-litigation/case-panel-litigation";
import CourtPanelLitigation from "@/Components/LitigationDashboard/new-components-litigation/court-panel-litigation";
import JudgePanelLitigation from "@/Components/LitigationDashboard/new-components-litigation/judge-panel-litigation";
import DefendantServicePanel from "@/Components/LitigationDashboard/new-components-litigation/defendant-service-panel";
import PlainTiffBlock from "@/Components/LitigationDashboard/new-components-litigation/plaintiff-block";
import DefendantBlockPanel from "@/Components/LitigationDashboard/new-components-litigation/defendant-block";

import { useFooter } from "../Components/common/shared/FooterContext"; // Assuming FooterContext is common, kept for usage.
import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import ActionBarLitigation from "../Components/LitigationDashboard/ActionBarLitigation";
// import LitigationNotes from "../Components/LitigationDashboard/LitigationNotes";
import LitigationTimeLines from "../Components/LitigationDashboard/LitigationTimelines";
import { setSearchRecordId } from "../Redux/search/searchSlice";
import { fetchPageObject, getCaseId, getClientId } from "../Utils/helper";
import { ClientDataContext } from "../Components/ClientDashboard/shared/DataContext";
import api, { api_without_cancellation } from "../api/api";
// import useIsStates from "../Hooks/getStates";
import Footer from "../Components/common/footer";
import ConfirmCancelPopUp from "../Components/Modals/ConfirmCancelPopUp";
import FilingsContent from "../Components/LitigationDashboard/LitigationTabInfo/FilingsContent";
import DiscoveryContent from "../Components/LitigationDashboard/LitigationTabInfo/DiscoveryContent";
import MotionContent from "../Components/LitigationDashboard/LitigationTabInfo/MotionContent";
import HearingContent from "../Components/LitigationDashboard/LitigationTabInfo/HearingContent";
import DespositionContent from "../Components/LitigationDashboard/LitigationTabInfo/DespositionContent";
import ExamContent from "../Components/LitigationDashboard/LitigationTabInfo/ExamContent";
import TrailContent from "../Components/LitigationDashboard/LitigationTabInfo/TrailContent";
import DeadlineContent from "../Components/LitigationDashboard/LitigationTabInfo/DeadlineContent";
import EventsContent from "../Components/LitigationDashboard/LitigationTabInfo/EventsContent";
import CourtFormTable from "../Components/CourtForm/CourtFormTable";
import NotEnablePopUp from "../Components/Modals/NotEnablePopUp";
import { useDocumentModal } from "../Components/common/CustomModal/CustomModalContext";
// import CourtFormPageSideMenu from "../Components/CourtForm/CourtFormSideBar/CourtFormPageSideMenu";
import GenerateCourtFormModalSideBar from "../Components/CourtForm/CourtFormSideBar/GenerateCourtFormModalSideBar";
import "./court-form.css";
function CourtForm() {
  const origin = process.env.REACT_APP_BACKEND_URL;

  const { setFooterState } = useFooter();

  const [formDataContext, setFormDataContext] = useState({});

  const token = getAuthorizationToken();
  const dispatch = useDispatch();
  const currentCaseId = getCaseId();
  const clientId = getClientId();
  const [litigationData, setLitigationData] = useState({});
  const [defendantsData, setDefendantsData] = useState([]);
  const [DefendantProcessedPageSlots, setDefendantProcessedPageSlots] = useState([]);
  const { isLitigationDashboardDataUpdate, setLitigationDashboardDataUpdated } =
    useContext(ClientDataContext);
  const [CardsData, setCardsData] = useState(false);
  const [firstTimeLitigationtData, setFirstTimeLitigationData] = useState(true);
  // const states = useIsStates();
  const searchRecordId = useSelector((state) => state.searchS.searchRecordId);
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (currentCaseId && !pageObject) {
      fetchPageObject(currentCaseId, 19).then((data) => {
        setPageObject(data);
      });
    }
  }, [currentCaseId, pageObject]);
  const [searchParams] = useSearchParams();
  // const docId = searchParams.get("docId");
  // const updatedDocId = searchParams.get("updatedDocId");

  const courtFormId = searchParams.get("court_form_id");

  // const redirectUrl = decodeURIComponent(searchParams.get("redirect_url"));
  const litigationId = searchParams.get("litigation_id");

  const [courtFormData, setCourtFormData] = useState(false);

  const [showConfirmPopUp, setShowConfirmPopUp] = useState(false);

  const [eventType, setEventType] = useState(false);
  const [litigationActObj, setLitigationActObj] = useState({});
  const [litigationObj, setLitigationObj] = useState({});

  const [validationPopUp, setValidationPopUp] = useState(false);
  const [validationText, setValidationText] = useState("");
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { showDocumentModal } = useDocumentModal();

  // const [courtFormPdf, setCourtFormPdf] = useState(null);
  const [courtFormPdfImages, setCourtFormPdfImages] = useState([]);
  const [showPdf, setShowPdf] = useState(false);
  const [variables, setVariables] = useState([]);
  // SideBar Start
  const [slotsData, setSlotsData] = useState([]);
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [clientInfo, setClientInfo] = useState(null);
  const [caseInfo, setCaseInfo] = useState(null);
  const [dataComplete, setDataComplete] = useState(false);

  const [_currentPage, setCurrentPage] = useState(0);
  const scrollRef = useRef(null);
  const [showRightSidebar, setShowRightSidebar] = useState(false);

  useEffect(() => {
    if (!scrollRef.current) return;

    const container = scrollRef.current;
    const sections = scrollRef.current.querySelectorAll(".page-section");

    const handleScroll = () => {
      let activeIndex = 0;

      sections.forEach((section, idx) => {
        const rect = section.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        if (rect.bottom <= containerRect.top + 25) {
          activeIndex = idx + 1;
        }
      });

      if (activeIndex >= sections.length) {
        activeIndex = sections.length - 1;
      }

      setCurrentPage(activeIndex);
    };

    // Run once on mount
    handleScroll();

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [variables.length > 0, dataComplete]);

  useEffect(() => {
    fetchVariables();
  }, [clientId, currentCaseId, courtFormId]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([fetchCourtImagesData(), fetchCourtTextData(), fecthData()]);
      } catch (error) {
        console.error("Error while feching data:", error);
      }
    };

    fetchAllData();
  }, []);

  const fetchClientPage = async () => {
    try {
      const response = await axios.get(
        `${origin}/api/get-client-by-id/?client_id=${getClientId()}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status === 200) {
        const client_data = response.data.client;
        // const user_data = response.data.user;
        setClientInfo(client_data);
        // setUserData(user_data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchCasePage = async () => {
    try {
      const response = await axios.get(
        `${origin}/api/cases/${clientId}/${currentCaseId}/summary/`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status === 200) {
        const case_data = response.data;
        setCaseInfo(case_data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchDataFirstTime = async () => {
    try {
      const response = await axios.get(
        `${origin}/api/general/get-attach-menu/?case_id=${currentCaseId}&client_id=${clientId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        setSlotsData(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDataFirstTime();
    fetchClientPage();
    fetchCasePage();
  }, [clientId, currentCaseId]);

  const fetchPageDetails = async (caseId) => {
    try {
      const response = await axios.get(`${origin}/api/pages/${caseId}/`, {
        headers: {
          Authorization: token,
        },
      });
      setPages(response.data);
    } catch (error) {
      console.error("Error occurred while fetching pages", error);
    }
  };

  useEffect(() => {
    setPages([]);
    if (currentCaseId) {
      fetchPageDetails(currentCaseId);
    }
  }, [currentCaseId]);

  const abortControllerRef = useRef(null);
  const refetchSlotsData = async () => {
    // Abort the previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create a new controller
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      const response = await axios.get(
        `${origin}/api/general/get-attach-menu/?case_id=${currentCaseId}&client_id=${clientId}`,
        {
          signal: controller.signal,
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        setSlotsData(response.data.data);
      }
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Previous API call aborted.");
      } else {
        console.error("API error:", error);
      }
    }
  };
  // SideBar End

  const handleRemoveSpaces = (value) => {
    // Remove extra spaces and trim leading/trailing spaces
    if (value) {
      const cleanedText = value.replace(/\s+/g, " ").trim();
      return cleanedText;
    }
  };

  const fetchVariables = async () => {
    try {
      const response = await axios.get(
        `${origin}/api/court-form/read-courtform-key/?court_form_id=${courtFormId}&case_id=${getCaseId()}&client_id=${getClientId()}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status === 200) {
        const variablesData = response.data.data;
        setVariables(variablesData);

        // Loop through the data and update the context for "variable"
        variablesData.forEach((page) => {
          const pageData = page.data;
          pageData.forEach((row) => {
            row.forEach((item) => {
              if (item.includes("\nvalue")) {
                const lines = item.split("\n");
                let text_value = "";
                let item_data = [];
                // eslint-disable-next-line unused-imports/no-unused-vars
                let key = null,
                  value = null;
                lines.forEach((line) => {
                  if (line.startsWith("value:/")) {
                    text_value = line.split(":/")[1];
                  } else if (line.startsWith("input:/")) {
                    item_data = line.split(":/");
                    key = handleRemoveSpaces(item_data[0]);
                    value = handleRemoveSpaces(item_data[1]);
                  }

                  setFormDataContext((prevState) => ({
                    ...prevState,
                    [value]: text_value,
                  }));
                });
              }
            });
          });
        });
      }
    } catch (error) {
      const error_text = "Court Form Key is not attached";
      setValidationText(error_text);
      setValidationPopUp(true);
      console.error("Failed to fetch client data:", error);
    }
  };

  const handleValidationPopUp = () => {
    setValidationPopUp(false);
  };

  const isSaveDisabled = useMemo(() => {
    return courtFormPdfImages.length < 1;
  }, [courtFormPdfImages]);

  useEffect(() => {
    if (!isSaveDisabled) {
      setShowPdf(true);
    } else {
      setShowPdf(false);
    }
  }, [isSaveDisabled]);

  const handleClose = () => {
    setShowConfirmPopUp(false);
  };

  const handleConfirm = () => {
    const redirect_url = "/bp-litigation/" + getClientId() + "/" + getCaseId();
    window.location.href = redirect_url;
  };

  const openCancelPopUp = () => {
    setShowConfirmPopUp(true);
  };

  const fecthData = async () => {
    if (litigationId !== "0") {
      try {
        const response = await api.get(
          `${origin}/api/litigation-page/litigation-act-by-id/?case_id=${currentCaseId}&client_id=${clientId}&litigation_act_id=${litigationId}`
        );

        setLitigationObj(response.data.litigation);
        setLitigationActObj(response.data.litigation_act);
        setEventType(response.data.type);
      } catch (error) {
        console.error("Failed to fetch Litigation Data:", error);
      }
    }
  };

  // const handleInputChange = (dataVariable, event) => {
  //   const { type, checked, value } = event.target;
  //   setFormDataContext((prevState) => ({
  //     ...prevState,
  //     [dataVariable]: type === "checkbox" ? (checked ? "X" : "") : value,
  //   }));
  // };

  const fetchEditDocs = async () => {
    try {
      const response = await api_without_cancellation.get(`${origin}/api/create-edit-doc/`);

      if (response.status === 200) {
        const data = response.data;

        setFooterState(data);
      }
    } catch (error) {
      console.error("Error fetching case types:", error);
    }
  };

  // const fetchCourtFormData = async () => {
  //   try {
  //     const response = await api_without_cancellation.get(
  //       `${origin}/api/court-form/get-courtform/?court_form_id=${courtFormId}`
  //     );
  //     if (response.status === 200) {
  //       const data = response.data.data;
  //       const cfpdf = response.data.court_form_pdf;
  //       const cfimgs = response.data.pdf_images.map((img) => img.upload);

  //       setCourtFormData(data);
  //       setCourtFormPdf(cfpdf);
  //       setCourtFormPdfImages(cfimgs);
  //       setDataComplete(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching case types:", error);
  //   } finally {
  //     setDataComplete(true);
  //   }
  // };

  const fetchCourtTextData = async () => {
    try {
      const response = await axios.get(
        `${origin}/api/court-form/court-form/?court_form_id=${courtFormId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        const data = response.data.data;
        setCourtFormData(data);
      }
    } catch (error) {
      console.error("Error fetching case types:", error);
    }
  };

  const fetchCourtImagesData = async () => {
    try {
      const response = await axios.get(
        `${origin}/api/court-form/court-form-pdf-images/?court_form_id=${courtFormId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        const cfimgs = response.data.pdf_images.map((img) => img.upload);
        setCourtFormPdfImages(cfimgs);
        setDataComplete(true);
      }
    } catch (error) {
      console.error("Error fetching case types:", error);
    } finally {
      setDataComplete(true);
    }
  };

  const createEditDoc = async (docId, url, name, dynamic_template_id) => {
    try {
      const redirect_url = `/bp-litigation/${getClientId()}/${getCaseId()}`;
      const formData = new FormData();
      formData.append("doc_id", docId);
      formData.append("url", url);
      formData.append("redirect_url", redirect_url);
      formData.append("name", name);
      formData.append("template_id", dynamic_template_id);

      const response = await api_without_cancellation.post(
        `${origin}/api/create-edit-doc/`,
        formData
      );
      if (response.status === 200) {
        fetchEditDocs();
      }

      // Proceed with additional logic if needed
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const openCourtForm = async () => {
    try {
      const formData = new FormData();

      const params = new URLSearchParams(window.location.search);
      const draftID = params.get("draft_id");

      formData.append("court_form_id", courtFormId);
      formData.append("case_id", getCaseId());
      formData.append("client_id", getClientId());
      formData.append("litigation_act_id", litigationId);
      formData.append("context", JSON.stringify(formDataContext));

      if (draftID) {
        formData.append("draft_id", draftID);
      }

      const response = await api_without_cancellation.post(
        origin + "/api/court-form/open-courtform/",
        formData
      );

      if (response.status === 200) {
        const doc_id = response.data.doc_id;
        const newBaseUrl = `/bp-wordprocessor/${getClientId()}/${getCaseId()}`;
        const url = `${newBaseUrl}/?docId=${doc_id}&litigation_id=${litigationId}&court_form_id=${courtFormId}&type=CourtForm`;
        await createEditDoc(doc_id, url, courtFormData?.court_form_name, "");

        window.location.href = url;
      } else {
        setValidationText(response.error);
        setValidationPopUp(true);
      }
    } catch (error) {
      const error_text = error.response.data.error;

      setValidationText(error_text);
      setValidationPopUp(true);
    }
  };

  const fetchLitigationData = async () => {
    try {
      const litigation_data = await axios.get(
        `${origin}/api/litigation-page/litigation/?case_id=${currentCaseId}&client_id=${clientId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (firstTimeLitigationtData) {
        setLitigationData(litigation_data.data);
        setDefendantsData(litigation_data.data?.defendants);
        setDefendantProcessedPageSlots(litigation_data.data?.defendant_processed_page_slots);
        setFirstTimeLitigationData(false);
      }
      if (isLitigationDashboardDataUpdate) {
        setLitigationData(litigation_data.data);
        setDefendantsData(litigation_data.data?.defendants);
        setDefendantProcessedPageSlots(litigation_data.data?.defendant_processed_page_slots);
        setLitigationDashboardDataUpdated(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  //data for components
  function settingCardsData() {
    const CardsDataSetter = {
      CaseData: {
        litigation_id: litigationData?.litigation?.id,
        case_short_name: litigationData?.litigation?.case_short_name,
        case_full_name: litigationData?.litigation?.case_full_name,
        case_number: litigationData?.litigation?.case_number,
        case_name: litigationData?.litigation?.case_name,
        state: litigationData?.litigation?.state,
        county: litigationData?.litigation?.county,
        jurisdiction_obj: litigationData?.litigation?.jurisdiction_obj,
        jurisdiction_type: litigationData?.litigation?.jurisdiction_type,
        DirCourt: litigationData?.litigation?.DirCourt,
        DirDepartment: litigationData?.litigation?.DirDepartment,
        court_contact: litigationData?.litigation?.court_contact,
        department_contact: litigationData?.litigation?.clerk_contact,
        court_name: litigationData?.litigation?.court_name,
        court_title1: litigationData?.litigation?.court_title1,
        court_title2: litigationData?.litigation?.court_title2,
        department: litigationData?.litigation?.department,
        clerk_first_name: litigationData?.litigation?.clerk_first_name,
        clerk_last_name: litigationData?.litigation?.clerk_last_name,
        floor: litigationData?.litigation?.floor,
        room: litigationData?.litigation?.room,
        deps: litigationData?.litigation?.deps,
        filing_type: litigationData?.litigation?.filing_type,
      },
      CourtData: {
        litigation_id: litigationData?.litigation?.id,
        courtId: litigationData?.litigation?.DirCourt?.id,
        county: litigationData?.litigation?.county,
        state: litigationData?.litigation?.state,
        jurisdiction_type: litigationData?.litigation?.jurisdiction_type,
        jurisdiction_obj: litigationData?.litigation?.jurisdiction_obj,
        court_name: litigationData?.litigation?.court_name,
        court_title1: litigationData?.litigation?.court_title1,
        court_title2: litigationData?.litigation?.court_title2,
        court_contact: litigationData?.litigation?.court_contact,
      },
      JudgeData: {
        courtId: litigationData?.litigation?.DirCourt?.id,
        litigation_id: litigationData?.litigation?.id,
        departmentId: litigationData?.litigation?.DirDepartment?.id,
        judgeId: litigationData?.litigation?.DirJudge?.id,
        judge_contact: litigationData?.litigation?.judge_department_contact,
        clerk_contact: litigationData?.litigation?.clerk_contact,
        judge_first_name: litigationData?.litigation?.judge_first_name,
        judge_last_name: litigationData?.litigation?.judge_last_name,
        department: litigationData?.litigation?.department,
        clerk_first_name: litigationData?.litigation?.clerk_first_name,
        clerk_last_name: litigationData?.litigation?.clerk_last_name,
        floor: litigationData?.litigation?.floor,
        room: litigationData?.litigation?.room,
        deps: litigationData?.litigation?.deps,
      },
      BlocksData: {
        litigation_id: litigationData?.litigation?.id || null,
        PlaBlock: litigationData?.litigation?.PlaBlock,
        DefBlock: litigationData?.litigation?.DefBlock,
      },
      // ClerkData: {
      //   litigation_id: litigationData?.litigation?.id,
      //   data: litigationData?.litigation?.DirDepartment,
      // },
    };
    return CardsDataSetter;
  }

  const CardsData2 = useMemo(() => {
    const litigation = litigationData?.litigation || {};

    return {
      ...litigation,
      litigation_id: litigation?.id || null,
      courtId: litigation?.DirCourt?.id || null,
      departmentId: litigation?.DirDepartment?.id || null,
      judgeId: litigation?.DirJudge?.id || null,
      judge_contact: litigation?.judge_department_contact,
      department_contact: litigation?.clerk_contact,
    };
  }, [litigationData?.litigation]);

  useEffect(() => {
    fetchLitigationData();
    setCardsData(settingCardsData());
    if (isLitigationDashboardDataUpdate) {
      setLitigationDashboardDataUpdated(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, currentCaseId, isLitigationDashboardDataUpdate]);

  useEffect(() => {
    setCardsData(settingCardsData());
  }, [litigationData]);

  // const sampleTimelineEvents = [
  //   {
  //     date: "2024-09-15",
  //     events: [
  //       {
  //         type: "Litigation",
  //         event: {
  //           is_allday: true,
  //           event_id: { event_name: "Court Hearing" },
  //         },
  //       },
  //       {
  //         type: "DefendantDates",
  //         event: {
  //           is_allday: true,
  //           event_id: { event_name: "Served Notice" },
  //         },
  //       },
  //     ],
  //   },
  //   {
  //     date: "2024-09-18",
  //     events: [
  //       {
  //         type: "Litigation",
  //         event: {
  //           is_allday: false,
  //           event_id: { event_name: "Motion Filed" },
  //         },
  //       },
  //     ],
  //   },
  // ];

  useEffect(() => {
    dispatch(setSearchRecordId(""));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchRecordId]);
  // const open = useSelector((state) => state?.open?.open);

  const renderContent = () => {
    switch (eventType) {
      case "Filing":
        return (
          <FilingsContent object={litigationActObj} name="Filing" litigation_obj={litigationObj} />
        );
      case "Hearing":
        return (
          <HearingContent object={litigationActObj} name="Hearing" litigation_obj={litigationObj} />
        );
      case "Motion":
        return (
          <MotionContent object={litigationActObj} name="Motion" litigation_obj={litigationObj} />
        );
      case "Discovery":
        return (
          <DiscoveryContent
            object={litigationActObj}
            name="Discovery"
            litigation_obj={litigationObj}
          />
        );
      case "Depos":
        return (
          <DespositionContent
            object={litigationActObj}
            name="Deposition"
            litigation_obj={litigationObj}
          />
        );
      case "Exam":
        return <ExamContent object={litigationActObj} name="Exam" litigation_obj={litigationObj} />;
      case "Trial":
        return (
          <TrailContent object={litigationActObj} name="Trial" litigation_obj={litigationObj} />
        );
      case "Deadline":
        return (
          <DeadlineContent
            object={litigationActObj}
            name="Deadline"
            litigation_obj={litigationObj}
          />
        );
      case "Event":
        return (
          <EventsContent object={litigationActObj} name="Event" litigation_obj={litigationObj} />
        );

      default:
        return;
    }
  };

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const containerRef = useRef(null);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="19" />
          <ActionBarLitigation pageObj={pageObject} LitigationDetail={CardsData.CaseData} />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            <>
              <div
                className="d-flex align-items-center justify-content-center w-100 height-25"
                style={{
                  background: "var(--primary)",
                  color: "white",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  marginBottom: "5px",
                  marginTop: "25px",
                }}
              >
                Case
              </div>
              <div className="flex-row d-flex m-t-0" style={{ overflow: "hidden", gap: "5px" }}>
                <div
                  className="m-b-5 flex-1 litigation-grid"
                  style={{
                    width: "calc(100% - 188px)",
                    height: "max-content",
                  }}
                  ref={containerRef}
                >
                  <div className="litigation-item case-item">
                    <CaseTabLitigation caseInfo={CardsData2} />
                  </div>

                  {/* Wrap Court and Judge together */}
                  <div className="litigation-item court-judge-wrapper">
                    <div className="court-item">
                      <CourtPanelLitigation court={CardsData2} />
                    </div>

                    <div className="judge-item">
                      <JudgePanelLitigation Judge={CardsData2} />
                    </div>
                  </div>

                  <div className="litigation-item service-item">
                    <DefendantServicePanel
                      caseInfo={CardsData2}
                      defendants={defendantsData}
                      defendantProcessedPageSlots={DefendantProcessedPageSlots}
                      fetchLitigationData={fetchLitigationData}
                      setLitigationDashboardDataUpdated={setLitigationDashboardDataUpdated}
                    />
                  </div>

                  {/* Wrap both blocks together */}
                  <div className="litigation-item blocks-wrapper">
                    <div className="plaintiff-block-item">
                      <PlainTiffBlock BlocksData={CardsData2} />
                    </div>
                    <div className="defendant-block-item">
                      <DefendantBlockPanel BlocksData={CardsData2} />
                    </div>
                  </div>
                </div>
                <div
                  className=" m-b-5"
                  style={{
                    width: "188px",
                    flex: "0 0 188px",
                  }}
                >
                  <LitigationTimeLines
                    sol_events={litigationData?.sol_events}
                    containerRef={containerRef}
                    summaryData={[]}
                  />
                </div>
              </div>
            </>

            {/* <div className="w-100" style={{ paddingTop: "35.6px" }}>
              <>
                <div className="litigation-main-wrapper-responsive flex-nowrap g-0 m-b-5 lit-wrapper-height w-100">
                  <div className="d-flex-1">
                    <div className="row g-0 equal-column-wrapper position-relative lit-page-section">
                      {isScreen100Case ? (
                        <div className="lit-upper-1 lit-upper-section-child">
                          <LitigationCase
                            caseInfo={CardsData.CaseData}
                            litigation_obj={litigationData?.litigation}
                          />
                        </div>
                      ) : (
                        <div className="lit-upper-1 lit-upper-section-child">
                          <LitigationCase
                            caseInfo={CardsData.CaseData}
                            litigation_obj={litigationData?.litigation}
                          />
                        </div>
                      )}
                      <LitigationCourtInfo
                        Court={CardsData.CourtData}
                        litigation_obj={litigationData?.litigation}
                      />
                      <LitigationJudgeInfo Judge={CardsData.JudgeData} />
                      {isScreen100 ? (
                        <div className="d-flex flex-grow-1 flex-column" style={{ rowGap: "5px" }}>
                          <LitigationDefendant
                            defendants={defendantsData}
                            defendantProcessedPageSlots={DefendantProcessedPageSlots}
                            fetchLitigationData={fetchLitigationData}
                            setIsClientDataUpdated={setLitigationDashboardDataUpdated}
                          />
                        </div>
                      ) : (
                        <>
                          <LitigationDefendant
                            defendants={defendantsData}
                            defendantProcessedPageSlots={DefendantProcessedPageSlots}
                            fetchLitigationData={fetchLitigationData}
                            setIsClientDataUpdated={setLitigationDashboardDataUpdated}
                          />
                        </>
                      )}
                      <DefendantPlaintiffBlock BlocksData={CardsData.BlocksData} />
                    </div>
                  </div>
                  <div
                    className="litigation-right content-right bg-white position-relative"
                    // id="right-timeline"
                  >
                    <div className="right-calendar border-0 p-0 h-100">
                      <LitigationTimeLines sol_events={litigationData?.sol_events} />
                    </div>
                  </div>
                </div>
              </>
            </div> */}

            {renderContent()}

            <div className="w-100 position-relative px-0">
              <div
                className={
                  "action-bar main-action-bar action-bar-editor-page client-BarAlign d-flex m-b-5 pr-15  notes-action-bar"
                }
                id="court-form-left-0px"
                style={{
                  position: "relative",
                  top: "0px",
                  left: "0px",
                  width: "100%",
                }}
              >
                <span
                  className="page-icon"
                  style={{
                    height: "35px",
                    width: "35px",
                    maxWidth: "35px",
                    flex: "0 0 35px",

                    // other styles can go here
                  }}
                >
                  <img
                    className="translate-note-icon"
                    src="https://simplefirm-bucket.s3.amazonaws.com/static/BP_resources/images/icon/courtforms.svg"
                  />
                </span>
                <>
                  <div className="text-wrapper text-nowrap text-white d-flex align-items-center p-l-5 w-100">
                    <div>
                      <p
                        className="text-white mb-0 text-uppercase"
                        style={{
                          cursor: "default",
                          fontWeight: "600",
                          fontSize: "18px",
                        }}
                      >
                        <span className="m-r-5">Court Form</span>
                        {courtFormData ? (
                          <span className="mx-auto text-center">
                            {courtFormData?.court_form_code} - {courtFormData?.court_form_name}
                          </span>
                        ) : null}
                      </p>
                    </div>
                    <div className="ms-auto">
                      {" "}
                      <span style={{ display: "flex", justifyContent: "center" }}>
                        <button
                          className={
                            "height-25 d-flex align-items-center justify-content-center btn btn-success"
                          }
                          onClick={() => setShowRightSidebar(!showRightSidebar)}
                        >
                          {showRightSidebar ? "Close" : "Open"} Controls
                        </button>
                      </span>
                    </div>
                  </div>
                </>
              </div>
              {/* <div className="notes-section-wrapper pt-0">
                <div className="action-bar-wrapper heigh-35 position-relative me-0 w-100">
                  <div
                    className="action-bar main-action-bar client-BarAlign d-flex m-b-5 pr-15 w-100"
                    style={{ paddingRight: "0px", paddingLeft: "0px" }}
                  >
                    <span className="page-icon">
                      <img
                        className="translate-note-icon"
                        src="https://simplefirm-bucket.s3.amazonaws.com/static/BP_resources/images/icon/courtforms.svg"
                      />
                    </span>
                    <div
                      className="text-wrapper text-nowrap text-white d-flex align-items-center p-l-5 w-100"
                      style={{ paddingRight: "0px", paddingLeft: "0px" }}
                    >
                      <h2 className="text-white mb-0 d-flex justify-content-between align-items-center w-100">
                        <span>Court Form</span>
                        {courtFormData ? (
                          <span className="mx-auto text-center">
                            {courtFormData?.court_form_code} - {courtFormData?.court_form_name}
                          </span>
                        ) : null}
                        
                        <span style={{ paddingRight: "5px" }}>
                          <button
                            className={
                              "height-25 d-flex align-items-center justify-content-center btn btn-success"
                            }
                            onClick={() => setShowRightSidebar(!showRightSidebar)}
                          >
                            {showRightSidebar ? "Close" : "Open"} Controls
                          </button>
                        </span>
                      </h2>
                    </div>
                  </div>
                </div>
              </div> */}
              {variables.length > 0 && dataComplete && (
                <div className="court-form-editor-layout m-t-5 m-l-5">
                  <div className="court-form-scroll-pane invisible-scrollbar" ref={scrollRef}>
                    <div className="court-form-scroll-content">
                      <div className="court-form-fields">
                        <div className="w-100 d-flex">
                          <button
                            className="btn btn-secondary me-auto height-25 d-flex align-items-center justify-content-center"
                            onClick={openCancelPopUp}
                          >
                            Cancel
                          </button>

                          {/* <button className="btn btn-primary ms-auto m-r-10" onClick={openCourtForm}>
                        Generate Court Form
                      </button> */}
                        </div>

                        <CourtFormTable
                          courtFormId={courtFormId}
                          formDataContext={formDataContext}
                          setFormDataContext={setFormDataContext}
                          setValidationPopUp={setValidationPopUp}
                          setValidationText={setValidationText}
                          showPdf={showPdf}
                          variables={variables}
                        />

                        <div className="w-100 d-flex mt-1">
                          <button
                            className="btn btn-secondary me-auto height-25 d-flex align-items-center justify-content-center"
                            onClick={openCancelPopUp}
                          >
                            Cancel
                          </button>

                          {/* <button className="btn btn-primary ms-auto m-r-10" onClick={openCourtForm}>
                        Generate Court Form
                      </button> */}
                        </div>
                      </div>
                      {showPdf && (
                        <div className="court-form-pdf-preview">
                          {/* {courtFormPdfImages.length > 0 && (
                        <img
                          src={courtFormPdfImages[currentPage]}
                          alt="PDF Preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            objectPosition: "top",
                          }}
                        />
                      )}{" "} */}
                          {courtFormPdfImages.length > 0 &&
                            courtFormPdfImages.map((image, index) => (
                              <img
                                key={index}
                                src={image}
                                alt={`PDF Preview ${index + 1}`}
                                style={{
                                  objectFit: "contain",
                                  objectPosition: "top",
                                }}
                              />
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                  {showRightSidebar && (
                    <div className="court-form-sidebar-shell">
                      {variables && (
                        <GenerateCourtFormModalSideBar
                          docData={""} // docData
                          pages={pages}
                          slotsData={slotsData}
                          onRefetchSlotsData={refetchSlotsData}
                          loading={loading}
                          setSlotsData={setSlotsData}
                          refetchDocumentData={""} // refetchDocumentData
                          litigationId={litigationId}
                          docId={""} // docId
                          fetchEditDocs={fetchEditDocs}
                          type="CourtForm"
                          container={"container"} // container
                          docName={courtFormData?.court_form_name}
                          state={"state"} // state
                          pageId={"pageId"} // pageId
                          courtFormId={courtFormId}
                          formDataContext={formDataContext}
                          clientId={clientId}
                          caseId={currentCaseId}
                          clientInfo={clientInfo}
                          caseInfo={caseInfo}
                          openCourtForm={openCourtForm}
                          showPdf={showPdf}
                          setShowPdf={setShowPdf}
                          isSaveDisabled={isSaveDisabled}
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
              className="mt-1"
              style={{
                height: "5px",
              }}
            />
          </div>
        </div>
      </div>
      {
        <ConfirmCancelPopUp
          show={showConfirmPopUp}
          handleConfirm={handleConfirm}
          handleClose={handleClose}
          title={"Do you want to cancel the court form generation and discard all changes?"}
        />
      }
      {
        <NotEnablePopUp
          confirmPopUp={validationPopUp}
          handleClose={handleValidationPopUp}
          title={validationText}
        />
      }
      <Footer />
    </>
  );
}

export default CourtForm;
